import { useQueryParam } from 'src/shared/hooks';
import { isBrowser } from 'src/shared/utils/environment';

import { HomeownerAppMenuNames } from '../providers/HomeownerAppProvider';

import { useHomeownerAppContext } from '.';

export const useShowSignInSheet = () => {
  const { setCurrentMenu } = useHomeownerAppContext();

  const showSignInSheet = useQueryParam('login') === 'true';

  if (isBrowser() && showSignInSheet) {
    setCurrentMenu(HomeownerAppMenuNames.SIGN_IN);
  }
};
